export class BlogModel {
  id: number;
  userId: number;
  url: string;
  deleted: boolean;
  version: number;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/network/blog.model.ts